/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Aaf_Mxf_TitleInputs */



/**
* | output |
* | --- |
* | "AAF/MXF Export" |
*
* @param {Subtitle_Export_Aaf_Mxf_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_aaf_mxf_title = /** @type {((inputs?: Subtitle_Export_Aaf_Mxf_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Aaf_Mxf_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exportation AAF/MXF")
	if (locale === "de") return /** @type {LocalizedString} */ ("AAF/MXF Export")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione AAF/MXF")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт AAF/MXF")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportación AAF/MXF")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("AAF/MXF 导出")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AAF/MXFエクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एएएफ/एमएक्सएफ निर्यात")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportação AAF/MXF")
	return /** @type {LocalizedString} */ ("AAF/MXF Export")
});